'use client';
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface OwnerData {
  owner: string;
  inspections: number;
  avgLsd: number;
  detained: number;
  criticalAvg: number;
}

interface Props {
  owners: OwnerData[];
}

export default function OwnerPerformanceTable({ owners }: Props) {
  return (
    <div className="overflow-x-auto scrollbar-thin">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b" style={{ borderColor: 'hsl(var(--border))' }}>
            {['Owner', 'Insp.', 'Avg LSD', 'Detained', 'Avg Critical'].map((h) => (
              <th key={`ownerth-${h}`} className="pb-2 text-left font-semibold uppercase tracking-wider text-muted pr-3 whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {owners.map((o) => (
            <tr key={`owner-${o.owner}`} className="border-b last:border-b-0 hover:bg-muted/30 transition-colors"
              style={{ borderColor: 'hsl(var(--border))' }}>
              <td className="py-2.5 pr-3 font-medium max-w-[140px] truncate" title={o.owner}>{o.owner}</td>
              <td className="py-2.5 pr-3 tabular-nums text-center font-semibold">{o.inspections}</td>
              <td className="py-2.5 pr-3">
                <span
                  className="font-mono font-bold tabular-nums px-1.5 py-0.5 rounded"
                  style={{
                    background: o.avgLsd > 60 ? 'hsl(355 75% 58% / 0.12)' : o.avgLsd > 40 ? 'hsl(38 92% 50% / 0.12)' : 'hsl(145 60% 40% / 0.12)',
                    color: o.avgLsd > 60 ? 'hsl(355 75% 38%)' : o.avgLsd > 40 ? 'hsl(38 72% 32%)' : 'hsl(145 60% 28%)',
                  }}
                >
                  {o.avgLsd}
                </span>
              </td>
              <td className="py-2.5 pr-3 text-center">
                {o.detained > 0 ? (
                  <span className="flex items-center gap-1 justify-center" style={{ color: 'hsl(var(--destructive))' }}>
                    <AlertTriangle size={11} />
                    <span className="font-bold tabular-nums">{o.detained}</span>
                  </span>
                ) : (
                  <span className="text-muted">—</span>
                )}
              </td>
              <td className="py-2.5">
                <span className={`font-mono font-semibold tabular-nums ${o.criticalAvg >= 5 ? 'text-red-600' : o.criticalAvg >= 3 ? 'text-amber-600' : 'text-muted'}`}>
                  {o.criticalAvg}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}